import { render, staticRenderFns } from "./BlockCardNewsList.vue?vue&type=template&id=76521a33&scoped=true&"
import script from "./BlockCardNewsList.vue?vue&type=script&lang=ts&"
export * from "./BlockCardNewsList.vue?vue&type=script&lang=ts&"
import style0 from "./BlockCardNewsList.vue?vue&type=style&index=0&id=76521a33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76521a33",
  null
  
)

export default component.exports